import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { customTheme } from './theme/theme';
import { AppLayout } from './components/app-layout';
import { RedirectToStatic } from './pages/static-redirect';
import { DataDeletionPage } from './pages/data-deletion-page';
import { HowPointsWorkPage } from './pages/how-points-work-page';
import { UserIdPage } from './pages/userid-page';
import { SettingsPage } from './pages/settings-page';
import { BRAND_NAME } from './config/brand';
import { useVersionCheck } from './hooks/use-version-check';

// BrowserRouter lives in index.tsx (above the data providers) so that
// SocialProvider can use useNavigate to clear OAuth callback params from
// the URL instead of calling window.history.replaceState directly — which
// bypassed react-router's internal state and left useLocation() stuck on
// the original pathname forever.
const App: React.FC = () => {
  useVersionCheck();

  React.useEffect(() => {
    document.title = BRAND_NAME;
  }, []);

  return (
    <ConfigProvider theme={customTheme}>
      <div className='App'>
        <Routes>
          <Route path='/' element={<AppLayout />} />
          <Route path='/connections' element={<AppLayout />} />
          <Route path='/ranking' element={<AppLayout />} />
          <Route path='/stats' element={<Navigate to='/mis-publicaciones' replace />} />
          <Route path='/mis-publicaciones' element={<AppLayout />} />
          <Route path='/settings' element={<AppLayout />} />
          {/* Legal pages: Terms of Service and Privacy Policy are two
              standalone documents (TikTok app-review required the split). */}
          <Route path='/privacy' element={<RedirectToStatic to='/privacy.html' />} />
          <Route path='/policy' element={<RedirectToStatic to='/privacy.html' />} />
          <Route path='/terms' element={<RedirectToStatic to='/terms.html' />} />
          <Route path='/how-points-work' element={<HowPointsWorkPage />} />
          <Route path='/data-deletion' element={<DataDeletionPage />} />
          {/* Admin: solo el panel operativo de staff (gated por AdminGuard + require_admin).
              El ranking de amplificadores y el detalle por usuario se movieron a Brands
              (vista por marca) → estas dos rutas redirigen a Brands. */}
          <Route path='/admin' element={<AppLayout />} />
          <Route path='/admin/ranking' element={<RedirectToStatic to='https://brands.doer.ar/social-admin' />} />
          <Route path='/admin/posts/:userId' element={<RedirectToStatic to='https://brands.doer.ar/social-admin' />} />
          <Route path='/userid' element={<UserIdPage />} />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default App;
